import { render, staticRenderFns } from "./addTaskBtn.vue?vue&type=template&id=908be774&"
import script from "./addTaskBtn.vue?vue&type=script&lang=js&"
export * from "./addTaskBtn.vue?vue&type=script&lang=js&"
import style0 from "../less/addTaskBtn.less?vue&type=style&index=0&module=true&lang=css&"
import style1 from "../less/select.less?vue&type=style&index=1&module=select&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
        cssModules["select"] = (style1.locals || style1)
        Object.defineProperty(this, "select", {
          configurable: true,
          get: function () {
            return cssModules["select"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/addTaskBtn.less?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("../less/addTaskBtn.less?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("908be774")
            }
          }
        })
      
        module.hot && module.hot.accept(["../less/select.less?vue&type=style&index=1&module=select&lang=css&"], function () {
          var oldLocals = cssModules["select"]
          if (oldLocals) {
            var newLocals = require("../less/select.less?vue&type=style&index=1&module=select&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["select"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("908be774")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('908be774')) {
      api.createRecord('908be774', component.options)
    } else {
      api.reload('908be774', component.options)
    }
    module.hot.accept("./addTaskBtn.vue?vue&type=template&id=908be774&", function () {
      api.rerender('908be774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/header/include/addTaskBtn.vue"
export default component.exports